import React, { useEffect, useState } from "react";
import { FaEdit, FaFileExport, FaPrint, FaSort, FaSortDown, FaSortUp } from "react-icons/fa";
import { Pagination, PaginationItem, PaginationLink, Table } from "reactstrap";
import { getGateEntryDetailsByUniqueId, getLabDetailsAPIURL } from "../commonServices/LabReportAPIURL";
import axios from "axios";
import moment from "moment";
import { toast } from "react-toastify";
import { printLabWithGateEntryReportAPIURL } from "../commonServices/LabAndGateEntryReportAPIURL";
import { pdfPathAPIURL } from "../commonServices/APIURL";

const LabDetailsTable = ({ data, setData, authUser, loader, setLoader, setEditFlag, setLabData, setLabModalOpen, setScanInput }) => {

    // GATE ENTRY MODAL
    const [gateModalOpen, setGateModalOpen] = useState(false);
    const [gateData, setGateData] = useState(null);

    const toggleGateModal = () => setGateModalOpen(!gateModalOpen);

    // console.log(JSON.stringify(data));
    // SEARCH
    const [searchTerm, setSearchTerm] = useState("");

    // SORTING
    const [sortField, setSortField] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");

    // ======================
    // PAGINATION STATES
    // ======================
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [currentPage, setCurrentPage] = useState(1);

    const handleRowsChange = (e) => {
        setRowsPerPage(Number(e.target.value));
        setCurrentPage(1); // reset
    };

    const handleNext = () => {
        setCurrentPage((prev) => (prev < totalPages ? prev + 1 : prev));
    };

    const handlePrev = () => {
        setCurrentPage((prev) => (prev > 1 ? prev - 1 : prev));
    };

    // ======================
    // SEARCH FILTER (WORKING NOW)
    // ======================
    const filteredData = data.filter((item) => {
        const q = searchTerm.toLowerCase();

        return (
            item.id?.toString().includes(q) ||
            item.entryDate?.toString().toLowerCase().includes(q) ||
            item.entryTime?.toString().toLowerCase().includes(q) ||
            item.uniqueId?.toString().toLowerCase().includes(q) ||   // FIXED 🎉
            item.fat?.toString().includes(q) ||
            item.density?.toString().includes(q) ||
            item.protein?.toString().includes(q) ||
            item.snf?.toString().includes(q)
        );
    });



    // ======================
    // SORT FUNCTION
    // ======================
    const handleSort = (field) => {
        const order = sortField == field && sortOrder == "asc" ? "desc" : "asc";
        setSortField(field);
        setSortOrder(order);
    };

    const sortedFilteredData = [...filteredData].sort((a, b) => {
        if (!sortField) return 0;
        if (a[sortField] < b[sortField]) return sortOrder == "asc" ? -1 : 1;
        if (a[sortField] > b[sortField]) return sortOrder == "asc" ? 1 : -1;
        return 0;
    });

    // ======================
    // PAGINATION (NOW WORKS WITH SEARCH)
    // ======================
    const totalRows = sortedFilteredData.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);

    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = Math.min(startIndex + rowsPerPage, totalRows);

    const paginatedData = sortedFilteredData.slice(startIndex, endIndex);

    // SORT ICON
    const sortIcon = (field) => {
        if (sortField != field)
            return <FaSort className="inline ml-1 text-gray-400" />;

        return sortOrder == "asc"
            ? <FaSortUp className="inline ml-1 text-indigo-600" />
            : <FaSortDown className="inline ml-1 text-indigo-600" />;
    };


    const fetchGateEntryDetails = async (uniqueId) => {
        // setLoader(true);
        if (!authUser?.token || authUser.token.trim() === "") {
            toast.error("Authorization token missing!");
            return; // 🔥 Stop here — do not call API
        }

        try {
            const resp = await axios.get(
                `${getGateEntryDetailsByUniqueId}?uniqueId=${uniqueId}`, {
                headers: {
                    'Authorization': `Bearer ${authUser.token}`,   // 👈 Add token here
                    // OR if your API expects another header name:
                    // "x-access-token": authUser.token
                }
            }
            );

            if (resp.data) {
                setGateData(resp.data);
                setLoader(false);
                setGateModalOpen(true);
            } else {
                setLoader(false);
                toast.error("No details found!");
            }
        } catch (error) {
            console.error(error);
            setLoader(false);
            toast.error("Failed to fetch gate entry details.");
        }
    };


    const printLabWithGateEntryReport = async () => {
        setLoader(true);

        if (!authUser?.token || authUser.token.trim() === "") {
            toast.error("Authorization token missing!");
            return; // 🔥 Stop here — do not call API
        }

        try {
            const resp = await axios.get(printLabWithGateEntryReportAPIURL, {
                headers: {
                    'Authorization': `Bearer ${authUser.token}`,   // 👈 Add token here
                    // OR if your API expects another header name:
                    // "x-access-token": authUser.token
                }
            });

            if (resp.data == "NOTFOUND") {
                setLoader(false);
                toast.warn("Not found!");
            }
            else {
                window.open(`${pdfPathAPIURL}${resp.data}`)
                setLoader(false);
            }
        } catch (error) {
            console.error("Error fetching gate entries:", error);
            setLoader(false);
            toast.error("Network error while printing!");
        }
    }


    // OPEN MODAL IN EDIT MODE
    const handleEditLab = (row) => {
        setLoader(true);

        setEditFlag(2);

        // Save ID + UniqueId for update
        setLabData(prev => ({
            ...prev,
            id: row.id,
            uniqueId: row.uniqueId,
            fat: row.fat,
            density: row.density,
            snf: row.snf,
            protein: row.protein,
            dateObj: new Date(`${row.entryDate}T${row.entryTime}`),
            dateTime: moment(`${row.entryDate} ${row.entryTime}`).format("YYYY-MM-DDTHH:mm")
        }));

        setScanInput(''); // Also show uniqueId in input if needed

        setLoader(false);
        setLabModalOpen(true);
    };



    return (
        <div className={authUser?.roleId == 2 ? "" : "mt-6"}>

            <div className="flex flex-col md:flex-row mb-6 items-start md:items-center">

                {/* Left Button (only shows if role != 2) */}
                {(authUser?.roleId == 2 || authUser?.roleId == 1) && (
                    <button
                        type="button"
                        className="
                                flex items-center gap-2
                                bg-gradient-to-r from-orange-500 to-orange-600
                                hover:from-orange-600 hover:to-orange-700
                                text-white px-4 py-2
                                rounded-lg shadow-md hover:shadow-lg
                                transition-all
                            "
                        onClick={() => printLabWithGateEntryReport()}
                    >
                        <FaFileExport /> Export Data
                    </button>

                )}

                {/* █████ SPACE PUSHER █████ */}
                <div className="flex-grow"></div>

                {/* Search Box */}
                <div className="relative w-full md:w-80 mt-3 md:mt-0">
                    <input
                        type="text"
                        placeholder="Search here..."
                        className="border border-gray-300 w-full px-4 py-2 rounded-lg shadow-sm 
                                   focus:ring-2 focus:ring-indigo-500"
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setCurrentPage(1);
                        }}
                    />
                    <span className="absolute right-4 top-2.5 text-gray-400">🔍</span>
                </div>
            </div>

            {/* TABLE */}
            <div className="overflow-x-auto border border-gray-300">
                <Table bordered responsive className="min-w-full border border-gray-300 rounded-md">

                    {/* HEADER */}
                    <thead>
                        <tr className="bg-indigo-50 text-indigo-700 border-b border-gray-300 text-center uppercase text-sm">
                            <th className="px-4 py-3 border border-indigo-300" rowSpan={2}>ID</th>
                            <th className="px-4 py-3 border border-indigo-300" rowSpan={2}>Date & Time</th>
                            <th className="px-4 py-3 border border-indigo-300" rowSpan={2}>Unique ID</th>
                            <th className="px-4 py-3 border border-indigo-300" colSpan={4}>Lab Details</th>
                            <th className="px-4 py-3 border border-indigo-300" rowSpan={2} hidden={(authUser?.roleId == 4) ? false : true}>Edit</th>
                            <th className="px-4 py-3 border border-indigo-300" rowSpan={2} hidden={(authUser?.roleId == 2 || authUser?.roleId == 1) ? false : true}>Action</th>

                        </tr>

                        <tr className="bg-indigo-50 text-center text-indigo-700 border-gray-300 uppercase text-xs font-semibold">
                            <th className="px-4 py-2 border border-indigo-300">Fat</th>
                            <th className="px-4 py-2 border border-indigo-300">Density</th>
                            <th className="px-4 py-2 border border-indigo-300">Protein</th>
                            <th className="px-4 py-2 border border-indigo-300">SNF</th>
                        </tr>
                    </thead>

                    {/* BODY */}
                    <tbody className="text-center text-gray-800 text-sm">

                        {paginatedData.map((row) => (
                            <tr key={row.id} className="hover:bg-indigo-50 transition border border-indigo-300">

                                <td className="px-4 py-3 border border-indigo-300">{row.id}</td>
                                <td className="px-4 py-3 border border-indigo-300">{moment(row.entryDate).format("DD/MM/YYYY")} {" " + row.entryTime}</td>
                                <td className="px-4 py-3 border border-indigo-300">{row.uniqueId}</td>

                                <td className="px-4 py-3 border border-indigo-300">{row.fat}</td>
                                <td className="px-4 py-3 border border-indigo-300">{row.density}</td>
                                <td className="px-4 py-3 border border-indigo-300">{row.protein}</td>
                                <td className="px-4 py-3 border border-indigo-300">{row.snf}</td>

                                <td className="px-4 py-3 border border-indigo-300" hidden={(authUser?.roleId == 4) ? false : true}>
                                    <div className="flex justify-center">
                                        <FaEdit
                                            size={20}
                                            className="text-green-700 cursor-pointer hover:text-green-800"
                                            onClick={() => handleEditLab(row)}
                                        />


                                    </div>
                                </td>

                                {/* --- Gate Entry Details Button --- */}
                                <td
                                    className="px-4 py-3 border border-indigo-300"
                                    hidden={(authUser?.roleId == 2 || authUser?.roleId == 1) ? false : true}
                                >
                                    <div className="flex justify-center">
                                        <button
                                            className="
                                                    bg-yellow-600 text-white text-xs font-medium 
                                                    px-3 py-1.5 rounded-md shadow-sm
                                                    hover:bg-yellow-700 hover:shadow transition
                                                    flex items-center justify-center gap-1
                                                "
                                            onClick={() => fetchGateEntryDetails(row.uniqueId)}
                                        >
                                            Gate Entry Details
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            {/* PAGINATION BAR */}
            <div className="flex justify-end items-center gap-5 mt-4 text-sm text-gray-700">

                {/* Rows Per Page */}
                <div className="flex items-center gap-2">
                    <span className="text-gray-600">Rows Per Page:</span>

                    <select
                        value={rowsPerPage}
                        onChange={handleRowsChange}
                        className="border border-gray-300 px-2 py-1 rounded-md text-sm 
                       shadow-sm hover:border-indigo-400 focus:ring-2 focus:ring-indigo-300"
                    >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                    </select>
                </div>

                {/* X–Y of Z */}
                <div className="text-gray-600 font-medium">
                    {startIndex + 1}-{endIndex} <span className="text-gray-500">of</span> {totalRows}
                </div>

                {/* Prev Button */}
                {/* Prev Button */}
                <button
                    className={`px-2 py-1 text-sm rounded-md font-semibold transition 
                    ${currentPage == 1
                            ? "text-gray-400 cursor-not-allowed"
                            : "text-indigo-600 hover:bg-indigo-100"
                        }`}
                    disabled={currentPage == 1}
                    onClick={handlePrev}
                >
                    &lt;
                </button>

                {/* Current Page (Circle) */}
                <span className="w-6 h-6 flex items-center justify-center 
                text-white bg-indigo-600 rounded-full 
                text-sm font-semibold shadow">
                    {currentPage}
                </span>

                {/* Next Button */}
                <button
                    className={`px-2 py-1 text-sm rounded-md font-semibold transition 
                        ${currentPage == totalPages
                            ? "text-gray-400 cursor-not-allowed"
                            : "text-indigo-600 hover:bg-indigo-100"
                        }`}
                    disabled={currentPage == totalPages}
                    onClick={handleNext}
                >
                    &gt;
                </button>


            </div>


            {/* <div className="flex justify-end mt-4">
                <Pagination
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "12px",
                        padding: 0,
                        margin: 0,
                        whiteSpace: "nowrap",
                        listStyle: "none"
                    }}
                >

                    
                    <PaginationItem
                        disabled={currentPage == 1}
                        style={{ display: "inline-flex" }}
                    >
                        <PaginationLink
                            onClick={() => setCurrentPage(1)}
                            className="bg-transparent border-none text-indigo-600 hover:text-indigo-800 font-bold"
                        >
                            ≪
                        </PaginationLink>
                    </PaginationItem>

                   
                    <PaginationItem
                        disabled={currentPage == 1}
                        style={{ display: "inline-flex" }}
                    >
                        <PaginationLink
                            onClick={handlePrev}
                            className="bg-transparent border-none text-indigo-600 hover:text-indigo-800 font-bold"
                        >
                            &lt;
                        </PaginationLink>
                    </PaginationItem>

                    
                    <PaginationItem active style={{ display: "inline-flex" }}>
                        <PaginationLink
                            className="px-3 py-1 rounded-full bg-indigo-600 text-white font-semibold shadow"
                            style={{ pointerEvents: "none" }}
                        >
                            {currentPage}
                        </PaginationLink>
                    </PaginationItem>

                    
                    <PaginationItem
                        disabled={currentPage == totalPages}
                        style={{ display: "inline-flex" }}
                    >
                        <PaginationLink
                            onClick={handleNext}
                            className="bg-transparent border-none text-indigo-600 hover:text-indigo-800 font-bold"
                        >
                            &gt;
                        </PaginationLink>
                    </PaginationItem>

                    
                    <PaginationItem
                        disabled={currentPage == totalPages}
                        style={{ display: "inline-flex" }}
                    >
                        <PaginationLink
                            onClick={() => setCurrentPage(totalPages)}
                            className="bg-transparent border-none text-indigo-600 hover:text-indigo-800 font-bold"
                        >
                            ≫
                        </PaginationLink>
                    </PaginationItem>

                </Pagination>
            </div> */}

            {gateModalOpen && gateData && (
                <div className="fixed inset-0 flex justify-center items-center z-50">

                    {/* --- Background Overlay with Blur --- */}
                    <div
                        className="absolute inset-0 bg-black bg-opacity-40 backdrop-blur-sm"
                        onClick={toggleGateModal}
                    ></div>

                    {/* --- Modal Card --- */}
                    <div className="
                            relative w-[450px] 
                            bg-white/80 backdrop-blur-md 
                            shadow-2xl rounded-2xl p-7 
                            border border-white/40
                            animate-slideUp
                        ">
                        {/* CLOSE BUTTON */}
                        <button
                            className="absolute top-3 right-4 text-red-500 text-2xl hover:text-red-700 transition"
                            onClick={toggleGateModal}
                        >
                            ✖
                        </button>

                        {/* TITLE */}
                        <h2 className="text-2xl font-bold text-indigo-700 text-center mb-4">
                            🚚 Gate Entry Details
                        </h2>

                        {/* COOL DIVIDER */}
                        <div className="w-20 h-1 bg-indigo-600 mx-auto rounded-full mb-6"></div>

                        {/* CONTENT */}
                        <div className="grid grid-cols-2 gap-4 text-gray-800 text-sm">

                            {/* <div>
                                <p className="font-semibold text-gray-600">ID</p>
                                <p className="mt-1 bg-white shadow-sm rounded-lg p-2">
                                    {gateData.id}
                                </p>
                            </div> */}

                            {/* <div>
                                <p className="font-semibold text-gray-600">Unique ID</p>
                                <p className="mt-1 bg-white shadow-sm rounded-lg p-2">
                                    {gateData.uniqueId}
                                </p>
                            </div> */}

                            <div>
                                <p className="font-semibold text-gray-600">Entry Date & Time</p>
                                <p className="mt-1 bg-white shadow-sm rounded-lg p-2">
                                    {moment(gateData.entryDate).format("DD/MM/YYYY")}  {gateData.entryTime}
                                </p>
                            </div>

                            <div>
                                <p className="font-semibold text-gray-600">Truck No</p>
                                <p className="mt-1 bg-white shadow-sm rounded-lg p-2">
                                    {gateData.truckNo}
                                </p>
                            </div>

                            <div>
                                <p className="font-semibold text-gray-600">Route No</p>
                                <p className="mt-1 bg-white shadow-sm rounded-lg p-2">
                                    {gateData.routeNo}
                                </p>
                            </div>

                            <div>
                                <p className="font-semibold text-gray-600">Society ID</p>
                                <p className="mt-1 bg-white shadow-sm rounded-lg p-2">
                                    {gateData.societyId}
                                </p>
                            </div>

                            <div>
                                <p className="font-semibold text-gray-600">Compartments</p>
                                <p className="mt-1 bg-white shadow-sm rounded-lg p-2">
                                    {gateData.compartments}
                                </p>
                            </div>



                            {/* <div>
                                <p className="font-semibold text-gray-600">Entry Time</p>
                                <p className="mt-1 bg-white shadow-sm rounded-lg p-2">
                                    {gateData.entryTime}
                                </p>
                            </div> */}

                        </div>

                        {/* BUTTON */}
                        <button
                            onClick={toggleGateModal}
                            className="
                                mt-6 w-full py-3
                                bg-gradient-to-r from-indigo-600 to-indigo-700
                                text-white rounded-xl text-lg font-semibold
                                shadow hover:shadow-lg hover:opacity-95
                                transition
                            "
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default LabDetailsTable;
